var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-container"},[_c('div',{staticClass:"logo"}),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('chat.room.message')))]),_c('Spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }